var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1333 9.01013L13.6987 14.4447C13.4771 14.6656 13.3011 14.928 13.1809 15.2168C13.0608 15.5057 12.9987 15.8155 12.9983 16.1283L12.9983 28.1559C12.9984 28.7872 13.2493 29.3927 13.6957 29.8391C14.1421 30.2855 14.7476 30.5364 15.3789 30.5365L24.908 30.5365C25.5394 30.5364 26.1448 30.2855 26.5912 29.8391C27.0377 29.3927 27.2885 28.7872 27.2886 28.1559L27.2886 16.1283C27.2882 15.8155 27.2262 15.5057 27.106 15.2168C26.9858 14.928 26.8099 14.6656 26.5882 14.4447L21.1536 9.01013C20.8857 8.74222 20.5223 8.59171 20.1435 8.59171C19.7646 8.59171 19.4012 8.74222 19.1333 9.01013ZM21.4903 16.7546C21.2239 17.021 20.8846 17.2024 20.5151 17.2759C20.1456 17.3494 19.7626 17.3117 19.4145 17.1675C19.0665 17.0234 18.769 16.7792 18.5597 16.466C18.3504 16.1528 18.2387 15.7845 18.2387 15.4078C18.2387 15.031 18.3504 14.6628 18.5597 14.3495C18.769 14.0363 19.0665 13.7922 19.4145 13.648C19.7626 13.5038 20.1456 13.4661 20.5151 13.5396C20.8846 13.6131 21.2239 13.7945 21.4903 14.0609C21.8475 14.4181 22.0482 14.9026 22.0482 15.4078C22.0482 15.9129 21.8475 16.3974 21.4903 16.7546Z",
    fill: "#333D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagListIcon);
export default __webpack_public_path__ + "static/media/tag-list-icon.ced12d1803add4a35b53f0f0e861a037.svg";
export { ForwardRef as ReactComponent };